var render = function render(){var _vm=this,_c=_vm._self._c;return _c('occupation',{attrs:{"occupation":_vm.occupation}})
}
var staticRenderFns = []

export { render, staticRenderFns }